import $ from 'jquery';
import '../../js/vertical-tabs-animate';


$(function setVerticalTabsForNosotros() {
  function getTab(tabValue) {
    const index = parseInt(tabValue, 10);

    switch (index) {
      case 0: return '.form-vertical-tab__content-mision';
      case 1: return '.form-vertical-tab__content-vision';
      case 2: return '.form-vertical-tab__content-valores';
    }
  }

  let currentTabIndex = 0;
  var ele = document.getElementsByName('tabs');
  for (var i = 0; i < ele.length; i++) {
    if (ele[i].checked)
      currentTabIndex = ele[i].value;
  }
  $(getTab(currentTabIndex)).addClass('active');
  $(getTab(currentTabIndex)).addClass('animate');


  $('input[type=radio][name=tabs]').click(function (e) {

    const index = this.value;

    if (index === parseInt(currentTabIndex, 10)) return;

    const $currentTab = $(getTab(currentTabIndex));
    const $nextTab = $(getTab(index));

    currentTabIndex = index;

    update($currentTab, $nextTab);

  });

  $('.form-vertical-tab__range').on('input', function () {
    const value = parseInt(this.value, 10);
    const steps = $('.form-vertical-tab__range').data('steps');
    const stepAmount = 1000 / steps;

    const index = Math.round(value / stepAmount);

    if (index === parseInt(currentTabIndex, 10)) return;

    const $currentTab = $(getTab(currentTabIndex));
    const $nextTab = $(getTab(index));

    currentTabIndex = index;
    update($currentTab, $nextTab);

  });


  function update($currentTab, $nextTab) {
    $currentTab.removeClass('active');
    $currentTab.removeClass('animate');

    $nextTab.addClass('active');

    // use setTimeout because jQuery batches together
    // addClass functions.
    setTimeout(function () {
      $nextTab.addClass('animate');
    }, 100);

  }


});